import React, { useCallback, useContext, useEffect, useState } from 'react';

import { Button, Table, Row, FormSelect } from '@digital/ui';
import { Tooltip } from 'antd';

import { downloadAnexoDemanda, excluiAnexo } from '../../../../../api/demanda';
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';
import ModalCreateDocumento from '../ModalCreateDocumento';
import ModalFinalizarEtapaDados from '../ModalFinalizarEtapaDados';
import ModalComentariosAnexoDemanda from '../ModalComentariosAnexoDemanda';
import { baixarTemplatesDemanda, baixarTemplateTakeOffAditivoPCS } from '@app/api/template';
import './custom.css';
import { getAllUsuariosRequisitantesOptions } from '@app/api/usuario';
import { getExportarTaKeOf } from '@app/api/contrato/planilhaQuantidadeContrato';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { UploadComponent } from '@app/components';

const UploadArquivosFields = () => {
  const { templateContext, getTemplates, demandaData, update, setUpdate, capex, opex } = useContext(
    QuestionarioContextProvider,
  );
  const [statusCode, setStatusCode] = useState<number>();

  useEffect(() => {
    async function fetchData() {
      await getTemplates(demandaData && demandaData.id);
    }
    if (demandaData) {
      setStatusCode(demandaData.statusCodigo);
    }

    fetchData();
  }, [demandaData, demandaData]);

  const handleExcluir = useCallback(
    async (id: string, obrigatorio: boolean) => {
      await excluiAnexo({ id, obrigatorio });
      setUpdate(!update);
      await getTemplates(demandaData && demandaData.id);
    },
    [getTemplates, demandaData],
  );

  const handleBaixarTemplates = () => {
    baixarTemplatesDemanda(demandaData.id);
  };

  const columns = [
    {
      title: 'Anexos',
      dataIndex: 'descricaoDocumento',
    },
    {
      title: 'Ações',
      width: '25%',
      className: 'td-centralizado',
      render: (index, record) => (
        <>
          {record && (
            <>
              {record.arquivoAtual && (
                <>
                  {!record.aprovado ? (
                    <UploadComponent
                      id={record.arquivos[0].id}
                      nomeIdFormulario={'Id'}
                      enderecoApi={'anexoDemanda/Upload'}
                      idDoComponente={record.id}
                      iconName="messaging-attach"
                      retorno={async data => {
                        if (data.valid) {
                          await getTemplates(demandaData && demandaData.id);
                        }
                      }}
                      hasFile={record.arquivoAtual && record.arquivoAtual.local}
                      label="Anexar"
                      buttonClass="labeled"
                    />
                  ) : (
                    <></>
                  )}
                </>
              )}
            </>
          )}
          {record.arquivoAtual && record.arquivoAtual.local && (
            <>
              <Tooltip title="Baixar Arquivo">
                <Button
                  id={`mrn-button-download-${record.id}`}
                  style={{ marginLeft: '10px' }}
                  icon="ui-download"
                  type="link"
                  onClick={() => {
                    downloadAnexoDemanda(record.arquivoAtual.id, record.arquivoAtual.nome);
                  }}
                  title="Baixar"
                  className="labeled"
                />
              </Tooltip>
            </>
          )}
          {record && !record.aprovado && (
            <Tooltip title="Excluir Anexo">
              <Button
                id={`mrn-button-delete-${record.id}`}
                style={{ marginLeft: '10px' }}
                type="link"
                icon="science-minus"
                onClick={() => {
                  handleExcluir(record.id, record.obrigatorio);
                }}
                disabled={statusCode === 7 || statusCode === 9 || statusCode === 2}
                title="Excluir"
                className="labeled"
              />
            </Tooltip>
          )}
        </>
      ),
    },
    {
      title: 'Comentários',
      dataIndex: 'historicoComentariosAnexoDemanda',
      width: '5%',
      className: 'td-centralizado',
      render: (index, record) => {
        return (
          <Tooltip title="Comentários">
            <ModalComentariosAnexoDemanda
              preSuprimentos={false}
              anexoId={record.id}
              contemComentario={record.historicoComentariosAnexoDemanda.length > 0}
            />
          </Tooltip>
        );
      },
    },
    {
      title: 'Status',
      width: '5%',
      render: (text, record) =>
        record.aprovado !== undefined ? (record.aprovado ? 'Validado' : 'Devolvido') : 'Pendente',
    },
  ];
  return (
    <>
      {statusCode === 1 && <ModalFinalizarEtapaDados />}
      {statusCode !== 7 && statusCode !== 2 && statusCode !== 9 && statusCode !== 6 && (
        <Row style={{ paddingLeft: '10px' }}>
          <ModalCreateDocumento getTemplates={getTemplates} />
          <Button
            style={{ borderRadius: '3px', marginBottom: '10px', marginLeft: '10px' }}
            type="primary"
            onClick={() => handleBaixarTemplates()}>
            Baixar Templates
          </Button>
          {demandaData && demandaData.contratoId != undefined && (
            <Button
              style={{ borderRadius: '3px', marginBottom: '10px', marginLeft: '10px' }}
              type="primary"
              onClick={() => {
                getExportarTaKeOf(demandaData.contratoId);
              }}>
              Exportar Take-Off
            </Button>
          )}
          {demandaData && demandaData.tipoContrato === 'pcs' && (
            <Button
              style={{ borderRadius: '3px', marginBottom: '10px', marginLeft: '10px' }}
              type="primary"
              onClick={() => {
                baixarTemplateTakeOffAditivoPCS();
              }}>
              Template Take-Off
            </Button>
          )}
        </Row>
      )}
      <Row style={{ paddingLeft: '10px', paddingRight: '5px' }}>
        <Table
          rowKey="id"
          id="mrn-table-demandas-UploadArquivosFields"
          columns={columns}
          dataSource={templateContext.filter(c => c.obrigatorio === true || c.automatico !== true) || []}
          pagination={false}
        />
      </Row>
      {demandaData && (!demandaData.requisicaoAbertaPeloDepPlanejamentoControle || opex) && (
        <fieldset>
          <legend>Indicação do Requisitante</legend>
          <Row>
            <FormSelect
              showSearch
              optionFilterProp="children"
              filterOption={(input: any, item: any) => {
                return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
              }}
              name="requisitanteId"
              label="Requisitante para gerar RC"
              getOptions={getAllUsuariosRequisitantesOptions}
              span={4}
              required
              disabled={opex && isObjNotEmpty(demandaData.administradorContratoId)}
            />
          </Row>
        </fieldset>
      )}
    </>
  );
};

export default UploadArquivosFields;
